import { Injectable } from '@angular/core';

import { BaseApiClientCustomFieldsV2Service } from './base-api-client-custom-fields-v2.service';

@Injectable({
	providedIn: 'root'
})
export class ApiClientCustomFieldsV2Service extends BaseApiClientCustomFieldsV2Service {}
